module.exports = __webpack_public_path__ + "img/eat_out_12.c37e51d9.jpg";